import { render, staticRenderFns } from "./notifications.pug?vue&type=template&id=14ce458b&functional=true&lang=pug&external"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ce458b')) {
      api.createRecord('14ce458b', component.options)
    } else {
      api.rerender('14ce458b', component.options)
    }
    module.hot.accept("./notifications.pug?vue&type=template&id=14ce458b&functional=true&lang=pug&external", function () {
      api.rerender('14ce458b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/index.vue"
export default component.exports